<template>
  <div class="conversation-actions">
    <div
      v-if="
        currentAgency &&
        currentConversation.status == 'active' &&
        activeVideoRoom &&
        activeVideoRoom.status === 'in-progress'"
      class="card border"
    >
      <div class="card-body">
        <VideoRoom :roomId="activeVideoRoom.room_id" />
      </div>
    </div>
    <div
      v-if="currentConversation.channel != 'media' &&
        currentConversation.status == 'active' &&
        currentConversation.recipients &&
        currentConversation.recipients.length > 0"
      class="card border"
    >
      <div class="card-body">
        <LocationWidget
          :recipientId="currentConversation.recipients[0].recipient_id"
          :recipientLabel="currentConversation.recipients[0].number"
          :conversationId="currentConversation.conversation_id"
        />
      </div>
    </div>
    <div
      v-if="currentAgency &&
        currentConversation.channel != 'media' &&
        agencySettings.videoEnabled &&
        currentConversation.status == 'active' &&
        currentConversation.recipients &&
        currentConversation.recipients.length > 0 &&
        !activeVideoRoom &&
        $auth.can('create:video_room')"
      class="card border"
    >
      <div class="card-body">
        <VideoRequestButton
          :conversationId="currentConversation.conversation_id"
          :recipientId="currentConversation.recipients[0].recipient_id"
          :recipientLabel="currentConversation.recipients[0].number"
          :recipientLanguage="currentRecipientLang"
        />
      </div>
    </div>
    <div
      v-if="currentAgency &&
        agencySettings['core:connectEnabled'] &&
        isSDKEnabled &&
        currentConversation.channel != 'media' &&
        currentConversation.recipients &&
        currentConversation.recipients.length > 0 &&
        currentConversation.status == 'active'"
      class="card border"
    >
      <div class="card-body">
        <InterpreterRequestButton
          :conversationId="currentConversation.conversation_id"
          :recipientId="currentConversation.recipients[0].recipient_id"
          :recipientLabel="currentConversation.recipients[0].number"
          :recipientLanguage="currentRecipientLang"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import LocationWidget from "../widgets/LocationWidget";
import VideoRequestButton from "../action_buttons/VideoRequestButton";
import VoiceSDKButton from "../action_buttons/VoiceSDKButton";
import VideoRoom from "../VideoRoom";
import MessageTemplates from "./MessageTemplates";
import InterpreterRequestButton from "../action_buttons/InterpreterRequestButton";

export default {
  name: "ConversationActions",
  components: {
    LocationWidget,
    VideoRequestButton,
    VoiceSDKButton,
    VideoRoom,
    MessageTemplates,
    InterpreterRequestButton,
  },
  props: {
    currentRecipientLang: String,
    conversationId: String,
  },
  computed: {
    ...mapGetters("agency", ["currentAgency", "agencySettings", "isSDKEnabled"]),
    ...mapGetters("conversations", ["currentConversation", "conversationStatus"]),
    ...mapGetters("video", ["videoRooms"]),
    ...mapGetters("user", ["currentUser"]),
    activeVideoRoom() {
      if (this.videoRooms && this.videoRooms.length > 0) {
        const activeVideoRoom = this.videoRooms.find(room => room.conversation_id == this.conversationId);
        if (activeVideoRoom && activeVideoRoom.status == "in-progress")
          return activeVideoRoom;
      }
      return null;
    },
  },
};
</script>

<style lang="scss" scoped>
.conversation-actions {
  width: 100%;
  max-width: 768px;

  .card {
    border-radius: 1rem;
    margin-bottom: 1rem;

    .card-body {
      padding: 1rem;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}

div .fa-3x {
  text-align: center;
  margin-top: 50px;
}

div .chat-message-translated {
  color: #8f8f8f;
  margin-top: 10px;
}

.chat-message-translated-lang {
  font-size: small;
  font-style: italic;
  color: #8f8f8f;
}
</style>
